import { render, staticRenderFns } from "./AppCardHeader.vue?vue&type=template&id=3ef1063a&scoped=true&lang=pug&"
import script from "./AppCardHeader.vue?vue&type=script&lang=js&"
export * from "./AppCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppCardHeader.vue?vue&type=style&index=0&id=3ef1063a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1063a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
